import {
  faEraser,
  faPenToSquare,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import CreateEmpresas from "../common/CreateEmpresas";
import BackButton from "../common/backButton";
import Footer from "../common/components/Footer";
import consts from "../consts";
import { cnpjMask } from "../functions/mask";

function Bancarios() {
  const [lista, setLista] = useState([]);
  const [filter, setFilter] = useState("");
  const [openEmpresa, setEmpresaOpen] = useState(false);
  const navigate = useNavigate();
  // const [viewMode, setViewMode] = useState(localStorage.planoViewMode);

  useEffect(() => {
    axios.get(`${consts.API_URL}/bancariosNonRepeated`).then((resp) => {
      setLista(resp.data);
    });
  }, []);

  return (
    <div className="min-h-screen dark:bg-[#121212] dark:text-white">
      <div className="container h-full mx-auto">
        <div className="flex">
          <BackButton path="home" text="Voltar" />
        </div>
        <div className="flex">
          <span className="text-4xl font-bold mt-3">Empresas</span>
        </div>
        <div className="flex justify-between gap-1 mt-5">
          <div className="flex flex-col gap-1">
            <span className="text-sm">Filtrar por nome</span>
            <div className="flex gap-2">
              <input
                type="text"
                className="p-3 border border-gray-300 rounded-md outline-none dark:text-black w-96"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                placeholder="Digite o nome da empresa"
              />
              {filter.length >= 1 ? (
                <Tooltip title="Limpar">
                  <button
                    className="px-4 py-2 bg-gray-100 rounded-md hover:bg-gray-300 dark:text-black"
                    onClick={() => setFilter("")}
                  >
                    <FontAwesomeIcon icon={faEraser} size={"lg"} />
                  </button>
                </Tooltip>
              ) : null}
            </div>
            <button
              onClick={() => setEmpresaOpen(true)}
              className="px-4 py-2 font-semibold text-center text-black bg-[#53D769] rounded-lg hover:bg-[#46C263] mt-5 w-[200px]"
            >
              <FontAwesomeIcon icon={faPlus} size="lg" className="w-5 h-5" />{" "}
              Cadastrar
            </button>
          </div>
        </div>
        <div className="grid justify-between grid-cols-4 p-4 mt-5 text-center font-bold  dark:bg-slate-700">
          {/* <span>Conta</span>
          <span>Agência</span> */}
          <span>CNPJ</span>
          <span className="self-center col-span-2">Empresa</span>
          {/* <span className="col-span-2">FID - Banco</span> */}
          <span>Editar</span>
        </div>

        <div className="flex flex-wrap">
          {lista
            .filter((val) =>
              filter === ""
                ? val
                : val.razaosocial
                    .toLowerCase()
                    .includes(filter.toLocaleLowerCase())
            )
            .map((item, index) => {
              return (
                <div
                  key={index}
                  className="grid w-full grid-cols-4 p-2 dark:bg-slate-800 gap-3 place-items-center font-medium bg-blue-50 mb-3 rounded-xl"
                  id={item.cnpj}
                >
                  <span className="p-2 border-2 border-gray-200 rounded-lg bg-white text-center w-[185px]">
                    {cnpjMask(item.cnpj)}
                  </span>

                  <span className="p-2 self-center col-span-2 bg-white text-center border-gray-200 border-2 rounded-lg w-[600px]">
                    {item.razaosocial}
                  </span>
                  {/* <span>{item.conta}</span> */}
                  {/* <span>{item.agencia}</span> */}

                  {/* <span className="col-span-2">
                    {item.fid} - {item.banco}
                  </span> */}
                  <div className="w-[150px] gap-2 text-center rounded-md dark:bg-yellow-700 dark:text-white p-2">
                    <button
                      className="px-4 py-2 bg-[#CCCCCC] rounded-md hover:bg-[#999999] text-black"
                      onClick={() => navigate(`/updateEmpresa/${item.cnpj}`)}
                    >
                      <FontAwesomeIcon icon={faPenToSquare} size="lg" />
                    </button>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
      <CreateEmpresas
        setLista={setLista}
        openEmpresa={openEmpresa}
        setEmpresaOpen={setEmpresaOpen}
      />
      <Footer />
    </div>
  );
}

export default Bancarios;
